import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import DisguisedBlockComponent from '../components/disguised-block/disguised-block'
import {intrinsicBlocksMap} from '../components/white-list/white-list.jsx'
import {handleModalVisible, selectDisguisedBlock} from "../reducers/disguised-block";
import bindAll from 'lodash.bindall';

// 支持的blockTypes
const SupportingBlockTypes = [
    'COMMAND'
];

// categoryBlackList
const CATEGORY_BLACK_LIST = [
    'operators',
    'variables',
    'myBlocks'
]

class CustomProcedures extends React.Component {

    static getDerivedStateFromProps (props, state) {
        // 如果是首次进入(默认值)使用当前已提交的状态
        if (state.selectedBlock === '' && props.selectedDisguisedBlock) {
            return {
                selectedBlock: props.selectedDisguisedBlock
            }
        }
    }

    constructor (props) {
        super(props);
        this.state = {
            selectedBlock: '',
            intrinsicBlocksMap: intrinsicBlocksMap
        };
        bindAll(this, [
            'onCancel',
            'onSave',
            'onSelectDisguisedBlock'
        ]);
    }

    onSave () {
        const {selectedBlock} = this.state;
        const disguisedBlockEngine = this.props.vm.disguisedBlockEngine;
        const alreadyLinkedBlocks = disguisedBlockEngine.findDisguisedBlockByOriginalOpcode(selectedBlock)
        // 校验不能重复关联伪装代码块
        if (selectedBlock && alreadyLinkedBlocks) {
            alert(`当前角色已经伪装了${selectedBlock}, 不能重复关联`)
            return
        }
        this.props.handleSelectDisguisedBlock(selectedBlock)
        this.props.handleDisguisedConfigModalVisible(false)
    }

    onSelectDisguisedBlock (blockInfo, event) {
        if (!event.currentTarget.checked) {
            this.setState({
                selectedBlock: null
            });
            return
        }
        const {category, opcode, value} = blockInfo;
        this.setState({
            selectedBlock: opcode
        });
    }

    onCancel () {
        this.props.handleDisguisedConfigModalVisible(false)
    }

    render () {
        const {selectedBlock, intrinsicBlocksMap} = this.state;
        const {modalVisible} = this.props;
        return (
            <DisguisedBlockComponent
                categoryBlackList={CATEGORY_BLACK_LIST}
                blockCategorizedMap={intrinsicBlocksMap}
                blockTypes={SupportingBlockTypes}
                visible={modalVisible}
                onSelectDisguisedBlock={this.onSelectDisguisedBlock}
                selectedDisguisedBlock={selectedBlock}
                onSave={this.onSave}
                onCancel={this.onCancel}
            />
        );
    }
}

CustomProcedures.propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    visible: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        modalVisible: state.scratchGui.disguisedBlock.modalVisible,
        selectedDisguisedBlock: state.scratchGui.disguisedBlock.selectedDisguisedBlock
    }
}
const mapDispatchToProps = dispatch => ({
    handleDisguisedConfigModalVisible: visible => dispatch(handleModalVisible(visible)),
    handleSelectDisguisedBlock: disguisedBlock => dispatch(selectDisguisedBlock(disguisedBlock))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomProcedures);
